exports.__esModule = true;
var __importDefault = function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var docs_config_1 = __importDefault(require("@tencent/docs-config"));
var appConfigInstance = docs_config_1.default.getInstance();
var npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
exports.default = (function () {
    var p = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.CDN_ORIGIN) || "https://docs.gtimg.com/docs-design-resources";
    p = p + "/mobile/png@2x/"
    return {
        "Direct purchase_tag@2x": p+"Direct purchase_tag@2x-8bd341f5db.png",
        "Logo__36@2x": p+"Logo__36@2x-eec1bc539e.png",
        "Openpage_text@2x": p+"Openpage_text@2x-f612cc11f8.png",
        "Qpan_appicon@2x": p+"Qpan_appicon@2x-2a423b8d08.png",
        "Qpan_chatbackup@2x": p+"Qpan_chatbackup@2x-3c3297cc20.png",
        "Qpan_chatbackup_bg@2x": p+"Qpan_chatbackup_bg@2x-bd28896f7c.png",
        "Qpan_freeusers@2x": p+"Qpan_freeusers@2x-caf389d78c.png",
        "Qpan_loadingscreen@2x": p+"Qpan_loadingscreen@2x-1d8d564061.png",
        "Qpan_loadingscreen_tengxunyun@2x": p+"Qpan_loadingscreen_tengxunyun@2x-3ddf645c2f.png",
        "Qpan_logo@2x": p+"Qpan_logo@2x-4288752645.png",
        "Qpan_logo_about@2x": p+"Qpan_logo_about@2x-944ca771c5.png",
        "Qpan_logo_crosswise@2x": p+"Qpan_logo_crosswise@2x-d85b88a51f.png",
        "Qpan_nochatbackup@2x": p+"Qpan_nochatbackup@2x-de2119bd09.png",
        "Qpan_nochatbackup_bg@2x": p+"Qpan_nochatbackup_bg@2x-98c1e55e0d.png",
        "Qpan_payingusers@2x": p+"Qpan_payingusers@2x-473f77dddc.png",
        "Qpan_storage@2x": p+"Qpan_storage@2x-53490237cc.png",
        "Qpan_tabbar_me_nor@2x": p+"Qpan_tabbar_me_nor@2x-fa6f9f98e8.png",
        "Qpan_tabbar_me_sel@2x": p+"Qpan_tabbar_me_sel@2x-f31491b2f6.png",
        "SOS@2x": p+"SOS@2x-54f4fb1e88.png",
        "TencentDoc_Open_bg@2x": p+"TencentDoc_Open_bg@2x-b7d6539f43.png",
        "account_list_outside_new@2x": p+"account_list_outside_new@2x-c88fd31d51.png",
        "account_list_outside_new_en@2x": p+"account_list_outside_new_en@2x-278f5496be.png",
        "account_list_outside_new_tc@2x": p+"account_list_outside_new_tc@2x-a124654553.png",
        "account_list_qiyewechat_new@2x": p+"account_list_qiyewechat_new@2x-6b48bf1513.png",
        "account_list_qiyewechat_new_en@2x": p+"account_list_qiyewechat_new_en@2x-e3ad4bc93e.png",
        "account_list_qiyewechat_new_tc@2x": p+"account_list_qiyewechat_new_tc@2x-29d4cf3262.png",
        "account_list_vip@2x": p+"account_list_vip@2x-115af8e6c0.png",
        "account_outside@2x": p+"account_outside@2x-eb85cabb68.png",
        "account_qiyewechat@2x": p+"account_qiyewechat@2x-603b6a7943.png",
        "ad_btn_skip@2x": p+"ad_btn_skip@2x-42cb1fcc33.png",
        "ad_logo@2x": p+"ad_logo@2x-ab3df314ed.png",
        "ad_text@2x": p+"ad_text@2x-1e1aaae81f.png",
        "add_36@2x": p+"add_36@2x-d5512b9190.png",
        "add_options@2x": p+"add_options@2x-f0ccf59b7a.png",
        "add_question_blue@2x": p+"add_question_blue@2x-f7a0b822f8.png",
        "add_question_btn@2x": p+"add_question_btn@2x-ee96e4b8b5.png",
        "add_question_btn_disable@2x": p+"add_question_btn_disable@2x-3c8fa0fa57.png",
        "album_32@2x": p+"album_32@2x-de6e017d6f.png",
        "android_b:u@2x": p+"android_b:u@2x-68509064bb.png",
        "app_1024": p+"app_1024-7a37b6e3d1.png",
        "app_120": p+"app_120-92cedb34ba.png",
        "app_144@2x": p+"app_144@2x-232060b139.png",
        "app_180": p+"app_180-8283a96ebc.png",
        "app_29": p+"app_29-9cd141a1d2.png",
        "app_40": p+"app_40-e34092e083.png",
        "app_512": p+"app_512-64cb0db67c.png",
        "app_58": p+"app_58-b3127a2d12.png",
        "app_60": p+"app_60-c467a3c00d.png",
        "app_80": p+"app_80-f1b3efc4f8.png",
        "app_87": p+"app_87-f1b3efc4f8.png",
        "app_96": p+"app_96-ed5d6b5c8f.png",
        "app_loading_logo_static@2x": p+"app_loading_logo_static@2x-e8b121d22c.png",
        "app_loading_logo_static_B@2x": p+"app_loading_logo_static_B@2x-c387f996cb.png",
        "app_loading_logo_static_en@2x": p+"app_loading_logo_static_en@2x-cfa665f504.png",
        "app_loading_logo_static_tc@2x": p+"app_loading_logo_static_tc@2x-168391705a.png",
        "app_official_account@2x": p+"app_official_account@2x-a8752c65c9.png",
        "appeal@2x": p+"appeal@2x-ed189b0c53.png",
        "appentry_OCR@2x": p+"appentry_OCR@2x-2758cb015a.png",
        "appentry_import@2x": p+"appentry_import@2x-a7046781ef.png",
        "appentry_qq@2x": p+"appentry_qq@2x-7b2c9cd91a.png",
        "appentry_transform@2x": p+"appentry_transform@2x-c73afde5c4.png",
        "appentry_voicenotes@2x": p+"appentry_voicenotes@2x-617ceb4d26.png",
        "appentry_wechat@2x": p+"appentry_wechat@2x-0b7a4794b9.png",
        "attachment_music@2x": p+"attachment_music@2x-afdce052dd.png",
        "authority_appoint@2x": p+"authority_appoint@2x-6d1e6fc97e.png",
        "authority_appoint_48@2x": p+"authority_appoint_48@2x-3235444787.png",
        "authority_edit@2x": p+"authority_edit@2x-7cd2ccc012.png",
        "authority_inside@2x": p+"authority_inside@2x-efe817eb79.png",
        "authority_outside@2x": p+"authority_outside@2x-3f3cdf89b8.png",
        "authority_private_48@2x": p+"authority_private_48@2x-7479b0d8a8.png",
        "authority_private_72@2x": p+"authority_private_72@2x-d98384b2ff.png",
        "authority_visible@2x": p+"authority_visible@2x-f2d19dfd79.png",
        "avatar_default_80@2x": p+"avatar_default_80@2x-2a69dd1dda.png",
        "avatar_tencentdocslogo@2x": p+"avatar_tencentdocslogo@2x-97e2f83ffd.png",
        "avatar_wechatwork@2x": p+"avatar_wechatwork@2x-fa3ee910cd.png",
        "avatar_wechatwork_file@2x": p+"avatar_wechatwork_file@2x-adcd8bf63b.png",
        "bg_account_wechatwork@2x": p+"bg_account_wechatwork@2x-c8afb30869.jpg",
        "bg_me@2x": p+"bg_me@2x-e427439f75.png",
        "btn_add_graybackground@2x": p+"btn_add_graybackground@2x-fc741481be.png",
        "buy_tag@2x": p+"buy_tag@2x-3ba330ee4f.png",
        "card_littletime@2x": p+"card_littletime@2x-16231bb52b.png",
        "cell_sendmessege@2x": p+"cell_sendmessege@2x-fc08d2c723.png",
        "checkbox-selected@2x": p+"checkbox-selected@2x-87c2eeebc1.png",
        "checkbox-unselected@2x": p+"checkbox-unselected@2x-7c7e67a5ac.png",
        "classlist_outline_regular_24@2x": p+"classlist_outline_regular_24@2x-7dcc66d747.png",
        "cloud@2x": p+"cloud@2x-fa45e5d694.png",
        "commonlist_outline_regular_24@2x": p+"commonlist_outline_regular_24@2x-6323dd57f7.png",
        "cube&logo618-2@2x": p+"cube&logo618-2@2x-29f8bc0ead.png",
        "cube&logo618@2x": p+"cube&logo618@2x-72b4207d23.png",
        "cube&logo@2x": p+"cube&logo@2x-ecf796e3b0.png",
        "cube&logo_en@2x": p+"cube&logo_en@2x-c10ac2e67a.png",
        "cube&logo_tc": p+"cube&logo_tc-f5e7746a58.png",
        "cube&logo_tc@2x": p+"cube&logo_tc@2x-46debf295f.png",
        "cube&logowithwording-2@2x": p+"cube&logowithwording-2@2x-931b2ab19e.png",
        "cube&logowithwording@2x": p+"cube&logowithwording@2x-2788370880.png",
        "data_date31_dark@2x": p+"data_date31_dark@2x-a0fa4a1df6.png",
        "delete_options@2x": p+"delete_options@2x-2aa01b968e.png",
        "dialog_bind@2x": p+"dialog_bind@2x-bee404b87a.png",
        "download_ arrow@2x": p+"download_ arrow@2x-bf95732bbd.png",
        "fast_add@2x": p+"fast_add@2x-8053d8d112.png",
        "file_aio_150@2x": p+"file_aio_150@2x-126f4cfa43.png",
        "file_aio_32@2x": p+"file_aio_32@2x-91728c80db.png",
        "file_aio_36@2x": p+"file_aio_36@2x-2b8dd6ba12.png",
        "file_aio_40@2x": p+"file_aio_40@2x-044720ec38.png",
        "file_aio_500@2x": p+"file_aio_500@2x-92a6a2c8cc.png",
        "file_aio_500@3x": p+"file_aio_500@3x-44f04b133e.png",
        "file_aio_64@2x": p+"file_aio_64@2x-f4fea7d35a.png",
        "file_aio_64_white@2x": p+"file_aio_64_white@2x-5952adf838.png",
        "file_aio_924@2x": p+"file_aio_924@2x-892bd23ffb.png",
        "file_aio_96@2x": p+"file_aio_96@2x-b56d73913f.png",
        "file_aio_quick_36@2x": p+"file_aio_quick_36@2x-7ce090ccfe.png",
        "file_aio_quick_64@2x": p+"file_aio_quick_64@2x-9afb436646.png",
        "file_aio_transparent_150@2x": p+"file_aio_transparent_150@2x-f480bd91a9.png",
        "file_change_excel@2x": p+"file_change_excel@2x-ebadff4a07.png",
        "file_change_pdf@2x": p+"file_change_pdf@2x-682fc4576d.png",
        "file_change_pdf_@2x": p+"file_change_pdf_@2x-45e697b461.png",
        "file_change_ppt@2x": p+"file_change_ppt@2x-146ae9e138.png",
        "file_change_word@2x": p+"file_change_word@2x-5bde6b65c9.png",
        "file_changelist_excel@2x": p+"file_changelist_excel@2x-2448834bfc.png",
        "file_changelist_ppt@2x": p+"file_changelist_ppt@2x-c14ea9a934.png",
        "file_changelist_word@2x": p+"file_changelist_word@2x-eff27ae6cc.png",
        "file_doc_150@2x": p+"file_doc_150@2x-4071023e84.png",
        "file_doc_32@2x": p+"file_doc_32@2x-55082cad58.png",
        "file_doc_40@2x": p+"file_doc_40@2x-70b04bffbe.png",
        "file_doc_500@2x": p+"file_doc_500@2x-23c68b245d.png",
        "file_doc_500@3x": p+"file_doc_500@3x-df09a73ae5.png",
        "file_doc_64@2x": p+"file_doc_64@2x-e4ab449c8e.png",
        "file_doc_64_white": p+"file_doc_64_white-68cf78ce1a.png",
        "file_doc_64_white@2x": p+"file_doc_64_white@2x-9cd26ab805.png",
        "file_doc_924@2x": p+"file_doc_924@2x-9da6265f04.png",
        "file_doc_96@2x": p+"file_doc_96@2x-f2fead3825.png",
        "file_doc_quick_64@2x": p+"file_doc_quick_64@2x-ca8b956b82.png",
        "file_doc_transparent_150@2x": p+"file_doc_transparent_150@2x-4ca08078e1.png",
        "file_drive_pdf_64@2x": p+"file_drive_pdf_64@2x-9e027094f7.png",
        "file_drive_ppt_150@2x": p+"file_drive_ppt_150@2x-4cfcea6a15.png",
        "file_drive_ppt_500@2x": p+"file_drive_ppt_500@2x-be7967ef15.png",
        "file_drive_ppt_924@2x": p+"file_drive_ppt_924@2x-5f77a18867.png",
        "file_drive_txt@2x": p+"file_drive_txt@2x-a07d28fbe4.png",
        "file_drive_txt_150@2x": p+"file_drive_txt_150@2x-192a34d2de.png",
        "file_drive_txt_500@2x": p+"file_drive_txt_500@2x-3f21a4dd42.png",
        "file_drive_txt_924@2x": p+"file_drive_txt_924@2x-85e6ecf425.png",
        "file_drive_unknown_150@2x": p+"file_drive_unknown_150@2x-1884c90460.png",
        "file_drive_unknown_36@2x": p+"file_drive_unknown_36@2x-551d0a4441.png",
        "file_drive_unknown_56@2x": p+"file_drive_unknown_56@2x-0ee7684b05.png",
        "file_drive_unknown_64_white@2x": p+"file_drive_unknown_64_white@2x-9e15def12c.png",
        "file_drive_visio_64@2x": p+"file_drive_visio_64@2x-5a48338466.png",
        "file_drive_word_150@2x": p+"file_drive_word_150@2x-396f181b2c.png",
        "file_drive_word_500@2x": p+"file_drive_word_500@2x-94d786665f.png",
        "file_drive_word_924@2x": p+"file_drive_word_924@2x-7d65d24b2c.png",
        "file_drive_xls_150@2x": p+"file_drive_xls_150@2x-e2eed434ed.png",
        "file_drive_xls_500@2x": p+"file_drive_xls_500@2x-82bde767f2.png",
        "file_drive_xls_924@2x": p+"file_drive_xls_924@2x-433707e0e3.png",
        "file_drive_xmind_64@2x": p+"file_drive_xmind_64@2x-5b9d461e11.png",
        "file_education_96@2x": p+"file_education_96@2x-7fb4d6b469.png",
        "file_empty_924@2x": p+"file_empty_924@2x-ecbed4950f.png",
        "file_excel_64_white": p+"file_excel_64_white-751d4962dd.png",
        "file_floder_64@2x": p+"file_floder_64@2x-f8665782dd.png",
        "file_floder_64_white@2x": p+"file_floder_64_white@2x-4a6974ad47.png",
        "file_floder_96@2x": p+"file_floder_96@2x-a795920a1b.png",
        "file_flowdiagram_150@2x": p+"file_flowdiagram_150@2x-b6fab7eb5b.png",
        "file_flowdiagram_32@2x": p+"file_flowdiagram_32@2x-855562daef.png",
        "file_flowdiagram_36@2x": p+"file_flowdiagram_36@2x-55526d13a6.png",
        "file_flowdiagram_40@2x": p+"file_flowdiagram_40@2x-98198cbee5.png",
        "file_flowdiagram_500@2x": p+"file_flowdiagram_500@2x-422cb37cc4.png",
        "file_flowdiagram_500@3x": p+"file_flowdiagram_500@3x-65d6607b29.png",
        "file_flowdiagram_64@2x": p+"file_flowdiagram_64@2x-39d1451bc7.png",
        "file_flowdiagram_64_white": p+"file_flowdiagram_64_white-84a9bde7ee.png",
        "file_flowdiagram_64_white@2x": p+"file_flowdiagram_64_white@2x-5dc4f37d0f.png",
        "file_flowdiagram_924@2x": p+"file_flowdiagram_924@2x-f96053db48.png",
        "file_flowdiagram_96@2x": p+"file_flowdiagram_96@2x-90ed6fd865.png",
        "file_flowdiagram_quick_64@2x": p+"file_flowdiagram_quick_64@2x-598975ac4c.png",
        "file_flowdiagram_transparent_150@2x": p+"file_flowdiagram_transparent_150@2x-5a376eaac6.png",
        "file_folder_150@2x": p+"file_folder_150@2x-4e82ff84f3.png",
        "file_folder_32@2x": p+"file_folder_32@2x-05172f1c9d.png",
        "file_folder_40@2x": p+"file_folder_40@2x-6fb48d4e95.png",
        "file_folder_420@2x": p+"file_folder_420@2x-69b296ff18.png",
        "file_folder_500@2x": p+"file_folder_500@2x-c4fecdc584.png",
        "file_folder_500@3x": p+"file_folder_500@3x-4b95880c3e.png",
        "file_folder_64@2x": p+"file_folder_64@2x-8277ab31a4.png",
        "file_folder_96@2x": p+"file_folder_96@2x-b4ef35fcc1.png",
        "file_folder_quick_64@2x": p+"file_folder_quick_64@2x-17554e5066.png",
        "file_folder_transparent_150@2x": p+"file_folder_transparent_150@2x-37e173fed6.png",
        "file_form_150@2x": p+"file_form_150@2x-a2d395a8be.png",
        "file_form_32@2x": p+"file_form_32@2x-9c18e0b0ab.png",
        "file_form_40@2x": p+"file_form_40@2x-12aeedfa3d.png",
        "file_form_500@2x": p+"file_form_500@2x-3f948a4a06.png",
        "file_form_500@3x": p+"file_form_500@3x-e43fc350b1.png",
        "file_form_64@2x": p+"file_form_64@2x-bbb262f6e7.png",
        "file_form_64_white": p+"file_form_64_white-bea7c0f38e.png",
        "file_form_64_white@2x": p+"file_form_64_white@2x-d814d6fa04.png",
        "file_form_924@2x": p+"file_form_924@2x-2879ad5584.png",
        "file_form_96@2x": p+"file_form_96@2x-34ecbfed07.png",
        "file_form_quick_64@2x": p+"file_form_quick_64@2x-7bc7ea754e.png",
        "file_form_transparent_150@2x": p+"file_form_transparent_150@2x-140167cfcf.png",
        "file_import_96@2x": p+"file_import_96@2x-5c08a89ce3.png",
        "file_import_new_96@2x": p+"file_import_new_96@2x-5c08a89ce3.png",
        "file_infocollect_96@2x": p+"file_infocollect_96@2x-ab385586b0.png",
        "file_mindmap_150@2x": p+"file_mindmap_150@2x-015f9b673e.png",
        "file_mindmap_32@2x": p+"file_mindmap_32@2x-f1872edb04.png",
        "file_mindmap_40@2x": p+"file_mindmap_40@2x-f94683c895.png",
        "file_mindmap_500@2x": p+"file_mindmap_500@2x-2482206366.png",
        "file_mindmap_500@3x": p+"file_mindmap_500@3x-e76f34a3e7.png",
        "file_mindmap_64@2x": p+"file_mindmap_64@2x-5cd1a78527.png",
        "file_mindmap_64_white": p+"file_mindmap_64_white-9b6505aa0f.png",
        "file_mindmap_64_white@2x": p+"file_mindmap_64_white@2x-6d37d18032.png",
        "file_mindmap_924@2x": p+"file_mindmap_924@2x-fe93967ba6.png",
        "file_mindmap_96@2x": p+"file_mindmap_96@2x-4be61cc9fd.png",
        "file_mindmap_quick_64@2x": p+"file_mindmap_quick_64@2x-141e0f9120.png",
        "file_mindmap_transparent_150@2x": p+"file_mindmap_transparent_150@2x-9b7a25c1ad.png",
        "file_ocr_96@2x": p+"file_ocr_96@2x-d24b7f7446.png",
        "file_pdf_150@2x": p+"file_pdf_150@2x-ff0f446e61.png",
        "file_pdf_32@2x": p+"file_pdf_32@2x-3612984ed6.png",
        "file_pdf_36@2x": p+"file_pdf_36@2x-f9791f7a6c.png",
        "file_pdf_40@2x": p+"file_pdf_40@2x-af66369935.png",
        "file_pdf_432@2x": p+"file_pdf_432@2x-ae700fd2c4.png",
        "file_pdf_500@2x": p+"file_pdf_500@2x-6bccb72f22.png",
        "file_pdf_500@3x": p+"file_pdf_500@3x-dfe1ea6840.png",
        "file_pdf_56@2x": p+"file_pdf_56@2x-c8a8e44cb0.png",
        "file_pdf_64@2x": p+"file_pdf_64@2x-5788417a4c.png",
        "file_pdf_64_white": p+"file_pdf_64_white-cef8614773.png",
        "file_pdf_64_white@2x": p+"file_pdf_64_white@2x-8942f60b89.png",
        "file_pdf_924@2x": p+"file_pdf_924@2x-5278115bdc.png",
        "file_pdf_96@2x": p+"file_pdf_96@2x-2da5bdee7a.png",
        "file_pdf_quick_64@2x": p+"file_pdf_quick_64@2x-6b9b314109.png",
        "file_pdf_transparent_150@2x": p+"file_pdf_transparent_150@2x-c3bd68ca17.png",
        "file_plugin_boardmix_64@2x": p+"file_plugin_boardmix_64@2x-526d5265a5.png",
        "file_plugin_pixso_64@2x": p+"file_plugin_pixso_64@2x-06ade6c179.png",
        "file_plugin_zhiying_64@2x": p+"file_plugin_zhiying_64@2x-09b9ee7037.png",
        "file_qqjizhang_500@2x": p+"file_qqjizhang_500@2x-5ce29a62b2.png",
        "file_quick_drive_excel_64@2x": p+"file_quick_drive_excel_64@2x-2c604a5669.png",
        "file_quick_drive_ppt_64@2x": p+"file_quick_drive_ppt_64@2x-792dbb91ca.png",
        "file_quick_drive_txt_64@2x": p+"file_quick_drive_txt_64@2x-9105108c44.png",
        "file_quick_drive_unknown_64@2x": p+"file_quick_drive_unknown_64@2x-ea92d84f06.png",
        "file_quick_drive_word_64@2x": p+"file_quick_drive_word_64@2x-120315ca92.png",
        "file_quick_workspace@2x": p+"file_quick_workspace@2x-161d913854.png",
        "file_sharefloder_64@2x": p+"file_sharefloder_64@2x-1b31745173.png",
        "file_sharefloder_64_white@2x": p+"file_sharefloder_64_white@2x-bea3a4fa38.png",
        "file_sharefloder_96@2x": p+"file_sharefloder_96@2x-155058bc30.png",
        "file_sharefolder_150@2x": p+"file_sharefolder_150@2x-109e3a74e0.png",
        "file_sharefolder_32@2x": p+"file_sharefolder_32@2x-7fe8759ba5.png",
        "file_sharefolder_40@2x": p+"file_sharefolder_40@2x-c0caf5513f.png",
        "file_sharefolder_500@2x": p+"file_sharefolder_500@2x-848e83bff4.png",
        "file_sharefolder_500@3x": p+"file_sharefolder_500@3x-e71d46ffde.png",
        "file_sharefolder_64@2x": p+"file_sharefolder_64@2x-392b8ce218.png",
        "file_sharefolder_64_white": p+"file_sharefolder_64_white-f8946c79ef.png",
        "file_sharefolder_quick_64@2x": p+"file_sharefolder_quick_64@2x-1f13dcf8c3.png",
        "file_sharefolder_transparent_150@2x": p+"file_sharefolder_transparent_150@2x-ba35272a40.png",
        "file_sheet_150@2x": p+"file_sheet_150@2x-ac5c642019.png",
        "file_sheet_32@2x": p+"file_sheet_32@2x-3f7e721ddb.png",
        "file_sheet_40@2x": p+"file_sheet_40@2x-48bef4d75f.png",
        "file_sheet_500@2x": p+"file_sheet_500@2x-bd3b45525b.png",
        "file_sheet_500@3x": p+"file_sheet_500@3x-bfa8dd3e8e.png",
        "file_sheet_64@2x": p+"file_sheet_64@2x-ea0885dc0d.png",
        "file_sheet_64_white@2x": p+"file_sheet_64_white@2x-df5dab90fe.png",
        "file_sheet_924@2x": p+"file_sheet_924@2x-541550f2b6.png",
        "file_sheet_96@2x": p+"file_sheet_96@2x-2a38b66691.png",
        "file_sheet_quick_64@2x": p+"file_sheet_quick_64@2x-1809ad9f6d.png",
        "file_sheet_transparent_150@2x": p+"file_sheet_transparent_150@2x-b9abfe8b37.png",
        "file_slide_150@2x": p+"file_slide_150@2x-0ab29c8bc3.png",
        "file_slide_32@2x": p+"file_slide_32@2x-1db5359d4f.png",
        "file_slide_40@2x": p+"file_slide_40@2x-d43e94aa84.png",
        "file_slide_500@2x": p+"file_slide_500@2x-963e727f0e.png",
        "file_slide_500@3x": p+"file_slide_500@3x-f5a5f0f9a5.png",
        "file_slide_64@2x": p+"file_slide_64@2x-4d8870062a.png",
        "file_slide_64_white": p+"file_slide_64_white-6497e5d536.png",
        "file_slide_64_white@2x": p+"file_slide_64_white@2x-eaf8aee18a.png",
        "file_slide_924@2x": p+"file_slide_924@2x-895e2831e0.png",
        "file_slide_96@2x": p+"file_slide_96@2x-069e5ad2eb.png",
        "file_slide_quick_64@2x": p+"file_slide_quick_64@2x-19614bb704.png",
        "file_slide_transparent_150@2x": p+"file_slide_transparent_150@2x-834ae7eccc.png",
        "file_smartcanvas_64@2x": p+"file_smartcanvas_64@2x-0c0743b99b.png",
        "file_smartsheet_150@2x": p+"file_smartsheet_150@2x-a94fc4626f.png",
        "file_smartsheet_500@2x": p+"file_smartsheet_500@2x-63b546afcd.png",
        "file_smartsheet_924@2x": p+"file_smartsheet_924@2x-383836244c.png",
        "file_smartsheet_transparent_150@2x": p+"file_smartsheet_transparent_150@2x-d939f9332d.png",
        "file_templates_96@2x": p+"file_templates_96@2x-2acd334a28.png",
        "file_voicenotes_150@2x": p+"file_voicenotes_150@2x-21ea095db2.png",
        "file_voicenotes_32@2x": p+"file_voicenotes_32@2x-8f32fa865b.png",
        "file_voicenotes_40@2x": p+"file_voicenotes_40@2x-f4d6fbaa50.png",
        "file_voicenotes_500@2x": p+"file_voicenotes_500@2x-f6cffe1536.png",
        "file_voicenotes_64@2x": p+"file_voicenotes_64@2x-83aa786eb1.png",
        "file_voicenotes_64_white@2x": p+"file_voicenotes_64_white@2x-8cc3cba415.png",
        "file_voicenotes_924@2x": p+"file_voicenotes_924@2x-05ee532a9b.png",
        "file_voicenotes_96@2x": p+"file_voicenotes_96@2x-328f2eeb88.png",
        "file_voicenotes_quick_64@2x": p+"file_voicenotes_quick_64@2x-ca821a8db6.png",
        "file_voicenotes_transparent_150@2x": p+"file_voicenotes_transparent_150@2x-250e74d6e2.png",
        "file_whiteboard_64@2x": p+"file_whiteboard_64@2x-eb9782303f.png",
        "file_work_96@2x": p+"file_work_96@2x-0153e5a067.png",
        "file_workspace_150@2x": p+"file_workspace_150@2x-07e4891f0b.png",
        "file_workspace_40@2x": p+"file_workspace_40@2x-49aed5dd0d.png",
        "file_workspace_500@2x": p+"file_workspace_500@2x-775b3889a8.png",
        "file_workspace_64@2x": p+"file_workspace_64@2x-f908e38166.png",
        "file_workspace_64_white": p+"file_workspace_64_white-0e096495c0.png",
        "file_workspace_924@2x": p+"file_workspace_924@2x-566dd5aa1b.png",
        "file_workspace_96@2x": p+"file_workspace_96@2x-2a56fb5f12.png",
        "file_x_64_white": p+"file_x_64_white-f331b3c691.png",
        "file_zip@2x": p+"file_zip@2x-4cba91e82e.png",
        "file_zip_500@2x": p+"file_zip_500@2x-d7e32c3b3b.png",
        "file_zip_64@2x": p+"file_zip_64@2x-e1b67cd0b5.png",
        "file_zip_64_white@2x": p+"file_zip_64_white@2x-e08b95a81e.png",
        "form_delete_white@2x": p+"form_delete_white@2x-67a350d324.png",
        "form_edit@2x": p+"form_edit@2x-db2bab64ca.png",
        "form_id_list@2x": p+"form_id_list@2x-26af73321f.png",
        "form_link_36@2x": p+"form_link_36@2x-10965ebacc.png",
        "form_link_48@2x": p+"form_link_48@2x-a7e6dbbffb.png",
        "form_photo@2x": p+"form_photo@2x-3adfef5941.png",
        "form_photo_48@2x": p+"form_photo_48@2x-f9c86e8ac9.png",
        "form_photo_white@2x": p+"form_photo_white@2x-87ab27e2d8.png",
        "form_qrcode@2x": p+"form_qrcode@2x-8e3c2c1a6b.png",
        "form_secondary_arrow_right_18@2x": p+"form_secondary_arrow_right_18@2x-200dd900c0.png",
        "form_secondary_arrow_right_36@2x": p+"form_secondary_arrow_right_36@2x-964ab1f280.png",
        "form_submitted@2x": p+"form_submitted@2x-7a10143820.png",
        "help_line@2x": p+"help_line@2x-54da3ea7b9.png",
        "icon_authority@2x": p+"icon_authority@2x-fbda934f42.png",
        "icon_category_white-file_smartcanvas_64_white": p+"icon_category_white-file_smartcanvas_64_white-35d734ce06.png",
        "icon_choosefrom_group@2x": p+"icon_choosefrom_group@2x-15b4dbbc7b.png",
        "icon_choosefrom_partner@2x": p+"icon_choosefrom_partner@2x-4b6af4ba52.png",
        "icon_choosefrom_qq@2x": p+"icon_choosefrom_qq@2x-a0dfa00806.png",
        "icon_choosefrom_tencentdocs@2x": p+"icon_choosefrom_tencentdocs@2x-5ef58f68c9.png",
        "icon_choosefrom_wechat@2x": p+"icon_choosefrom_wechat@2x-8051913004.png",
        "icon_choosefrom_wechatwork@2x": p+"icon_choosefrom_wechatwork@2x-d6835972ee.png",
        "icon_choosefrom_wechatwork_group@2x": p+"icon_choosefrom_wechatwork_group@2x-31d1903733.png",
        "icon_dialog_close@2x": p+"icon_dialog_close@2x-b135f81c41.png",
        "icon_file_drive_ppt@2x": p+"icon_file_drive_ppt@2x-77c7bc4ca2.png",
        "icon_file_drive_word@2x": p+"icon_file_drive_word@2x-bc19a7585d.png",
        "icon_file_drive_xls@2x": p+"icon_file_drive_xls@2x-cf8b0b364b.png",
        "icon_filter-file_smartcanvas_32": p+"icon_filter-file_smartcanvas_32-3210f739d7.png",
        "icon_input_protected@2x": p+"icon_input_protected@2x-8fc413b459.png",
        "icon_list_invite@2x": p+"icon_list_invite@2x-13e7d6d215.png",
        "icon_login_loading@2x": p+"icon_login_loading@2x-7313eaba2c.png",
        "icon_login_phone@2x": p+"icon_login_phone@2x-75dd376c5a.png",
        "icon_login_qq@2x": p+"icon_login_qq@2x-1011591f57.png",
        "icon_login_wechat@2x": p+"icon_login_wechat@2x-d3751824c3.png",
        "icon_modal_close@2x": p+"icon_modal_close@2x-94835f666b.png",
        "icon_navigation_back_grey@2x": p+"icon_navigation_back_grey@2x-efa7c3c16f.png",
        "icon_navigation_filter@2x": p+"icon_navigation_filter@2x-5bc4cf0cf6.png",
        "icon_navigation_filter_blue@2x": p+"icon_navigation_filter_blue@2x-f98e738609.png",
        "icon_notice_72@2x": p+"icon_notice_72@2x-09f661f6a7.png",
        "icon_notice_84@2x": p+"icon_notice_84@2x-dfdb0dea27.png",
        "icon_notification-file_smartcanvas_40": p+"icon_notification-file_smartcanvas_40-9f7d32e2c5.png",
        "icon_plugin_ID photo24x24": p+"icon_plugin_ID photo24x24-fb83818acc.png",
        "icon_plugin_qqmusic@2x": p+"icon_plugin_qqmusic@2x-1add6d918c.png",
        "icon_radiobutton_normal@2x": p+"icon_radiobutton_normal@2x-65debc5496.png",
        "icon_radiobutton_normal_disable@2x": p+"icon_radiobutton_normal_disable@2x-f1e21fe9ff.png",
        "icon_radiobutton_selected@2x": p+"icon_radiobutton_selected@2x-6c58497827.png",
        "icon_radiobutton_selected_disable@2x": p+"icon_radiobutton_selected_disable@2x-d648de1d45.png",
        "icon_rename_gray@2x": p+"icon_rename_gray@2x-c5d6ecf34c.png",
        "icon_ridiobutton_normal_white@2x": p+"icon_ridiobutton_normal_white@2x-e90c02e0d4.png",
        "icon_ridiobutton_small_nor@2x": p+"icon_ridiobutton_small_nor@2x-4b3b6779df.png",
        "icon_ridiobutton_small_sel@2x": p+"icon_ridiobutton_small_sel@2x-826a0e13cd.png",
        "icon_scanning@2x": p+"icon_scanning@2x-9abe6a59a7.png",
        "icon_search@2x": p+"icon_search@2x-5d8709a1f3.png",
        "icon_secondary_addfriends@2x": p+"icon_secondary_addfriends@2x-2a240c8d34.png",
        "icon_secondary_arrow_left@2x": p+"icon_secondary_arrow_left@2x-944cfebd1b.png",
        "icon_secondary_arrow_right@2x": p+"icon_secondary_arrow_right@2x-1ba96ce0ae.png",
        "icon_secondary_arrow_right_24@2x": p+"icon_secondary_arrow_right_24@2x-a6c61bf065.png",
        "icon_secondary_arrow_right_white@2x": p+"icon_secondary_arrow_right_white@2x-5ab1908cc2.png",
        "icon_secondary_close@2x": p+"icon_secondary_close@2x-9d86c1b057.png",
        "icon_secondary_legalize@2x": p+"icon_secondary_legalize@2x-6c53ec69f6.png",
        "icon_secondary_loading@2x": p+"icon_secondary_loading@2x-f91547e56c.png",
        "icon_secondary_star_fill@2x": p+"icon_secondary_star_fill@2x-f207a71910.png",
        "icon_secondary_star_line@2x": p+"icon_secondary_star_line@2x-acf410ef05.png",
        "icon_secondary_sync_fail@2x": p+"icon_secondary_sync_fail@2x-3119a9ade4.png",
        "icon_secondary_sync_ing@2x": p+"icon_secondary_sync_ing@2x-5ac2901de1.png",
        "icon_secondary_sync_success@2x": p+"icon_secondary_sync_success@2x-6477d17555.png",
        "icon_secondary_sync_waiting@2x": p+"icon_secondary_sync_waiting@2x-616a2265b3.png",
        "icon_secondary_synchronizing@2x": p+"icon_secondary_synchronizing@2x-061dc382dc.png",
        "icon_secondary_tick@2x": p+"icon_secondary_tick@2x-55ad445fb1.png",
        "icon_secondary_vip@2x": p+"icon_secondary_vip@2x-ae9e331c15.png",
        "icon_secondary_wifi@2x": p+"icon_secondary_wifi@2x-f75280a0f1.png",
        "icon_shareto_computer@2x": p+"icon_shareto_computer@2x-a60b95d1e8.png",
        "icon_shareto_friendscircle@2x": p+"icon_shareto_friendscircle@2x-17fa8d4055.png",
        "icon_shareto_kandian@2x": p+"icon_shareto_kandian@2x-029983bb5c.png",
        "icon_shareto_link@2x": p+"icon_shareto_link@2x-755f5be5d0.png",
        "icon_shareto_miniprograms@2x": p+"icon_shareto_miniprograms@2x-8bf00b37b5.png",
        "icon_shareto_pdf@2x": p+"icon_shareto_pdf@2x-6d2605624e.png",
        "icon_shareto_qq@2x": p+"icon_shareto_qq@2x-3066d59a01.png",
        "icon_shareto_qrcode@2x": p+"icon_shareto_qrcode@2x-2a7b85ea40.png",
        "icon_shareto_qzone@2x": p+"icon_shareto_qzone@2x-5c6d5f23dc.png",
        "icon_shareto_tim@2x": p+"icon_shareto_tim@2x-30bad9898d.png",
        "icon_shareto_wechat@2x": p+"icon_shareto_wechat@2x-a425ac5548.png",
        "icon_shareto_wechatwork@2x": p+"icon_shareto_wechatwork@2x-6dd51831c8.png",
        "icon_shareto_weibo@2x": p+"icon_shareto_weibo@2x-9d58bb0b99.png",
        "icon_shortcut-file_smartcanvas_quick_64": p+"icon_shortcut-file_smartcanvas_quick_64-1eb0aa7023.png",
        "icon_sort@2x": p+"icon_sort@2x-1de5b164b3.png",
        "icon_storage_24x24": p+"icon_storage_24x24-15d8e9128a.png",
        "icon_stub-ist_share_smartcanvas": p+"icon_stub-ist_share_smartcanvas-734b510076.png",
        "icon_svip_diamond_24x24": p+"icon_svip_diamond_24x24-44e8cdb411.png",
        "icon_tag_list_nopermission_cn@2x": p+"icon_tag_list_nopermission_cn@2x-9722a8b84b.png",
        "icon_tag_list_nopermission_en@2x": p+"icon_tag_list_nopermission_en@2x-7e8a0b3afa.png",
        "icon_tasklist@2x": p+"icon_tasklist@2x-bf75c56053.png",
        "icon_template_24x24": p+"icon_template_24x24-9309d6133f.png",
        "icon_thirdary_arrow_fill_down_blue@2x": p+"icon_thirdary_arrow_fill_down_blue@2x-02c65b4eed.png",
        "icon_thirdary_arrow_fill_down_grey@2x": p+"icon_thirdary_arrow_fill_down_grey@2x-ec8daa0d4a.png",
        "icon_thirdary_arrow_fill_right_grey@2x": p+"icon_thirdary_arrow_fill_right_grey@2x-c92f52816d.png",
        "icon_thirdary_arrow_fill_up_blue@2x": p+"icon_thirdary_arrow_fill_up_blue@2x-46c5f3baf5.png",
        "icon_thirdary_arrow_fill_up_grey@2x": p+"icon_thirdary_arrow_fill_up_grey@2x-370a669e52.png",
        "icon_thirdary_arrow_right@2x": p+"icon_thirdary_arrow_right@2x-9491ce2af9.png",
        "icon_thirdary_arrow_right_black@2x": p+"icon_thirdary_arrow_right_black@2x-f0b235d898.png",
        "icon_thirdary_close@2x": p+"icon_thirdary_close@2x-acec4bada9.png",
        "icon_thirdary_close_36@2x": p+"icon_thirdary_close_36@2x-c6f37cc9eb.png",
        "icon_thirdary_comment_grey@2x": p+"icon_thirdary_comment_grey@2x-a98a4e9b4a.png",
        "icon_thirdary_filter@2x": p+"icon_thirdary_filter@2x-443247142e.png",
        "icon_thirdary_filter_blue@2x": p+"icon_thirdary_filter_blue@2x-660cbe2238.png",
        "icon_thirdary_loading@2x": p+"icon_thirdary_loading@2x-753e130103.png",
        "icon_thirdary_online@2x": p+"icon_thirdary_online@2x-efc028cf05.png",
        "icon_thirdary_safety@2x": p+"icon_thirdary_safety@2x-70f0840835.png",
        "icon_thirdary_share@2x": p+"icon_thirdary_share@2x-dfb10508be.png",
        "icon_thirdary_star@2x": p+"icon_thirdary_star@2x-73cb92c27c.png",
        "icon_thirdary_tag_enterprisewechat@2x": p+"icon_thirdary_tag_enterprisewechat@2x-7faab55cc4.png",
        "icon_thirdary_tag_group@2x": p+"icon_thirdary_tag_group@2x-8474a2267e.png",
        "icon_thirdary_tag_new_enterprisewechat@2x": p+"icon_thirdary_tag_new_enterprisewechat@2x-08674bbf4a.png",
        "icon_thirdary_tag_new_qq@2x": p+"icon_thirdary_tag_new_qq@2x-70bf64eff7.png",
        "icon_thirdary_tag_new_wechat@2x": p+"icon_thirdary_tag_new_wechat@2x-ee2ca8352c.png",
        "icon_thirdary_tag_qq@2x": p+"icon_thirdary_tag_qq@2x-0ddf10558b.png",
        "icon_thirdary_tag_tick@2x": p+"icon_thirdary_tag_tick@2x-601a6b0fcc.png",
        "icon_thirdary_tag_wechat@2x": p+"icon_thirdary_tag_wechat@2x-13b1f91501.png",
        "icon_thirdary_transferarrow@2x": p+"icon_thirdary_transferarrow@2x-59bf1f3b18.png",
        "icon_thirdary_transferarrow_stop@2x": p+"icon_thirdary_transferarrow_stop@2x-f1a5077a0d.png",
        "icon_thirdary_wechatwork@2x": p+"icon_thirdary_wechatwork@2x-ccdcf56b52.png",
        "icon_thirdary_zan_normal@2x": p+"icon_thirdary_zan_normal@2x-05e7e1d535.png",
        "icon_thirdary_zan_selected@2x": p+"icon_thirdary_zan_selected@2x-8d36f5af91.png",
        "icon_tips_close@2x": p+"icon_tips_close@2x-56b4806e0d.png",
        "icon_tips_loading_reload_1@2x": p+"icon_tips_loading_reload_1@2x-7d02fa114c.png",
        "icon_tips_loading_reload_2@2x": p+"icon_tips_loading_reload_2@2x-0d93909682.png",
        "icon_toast_info@2x": p+"icon_toast_info@2x-8d4c5cb2cc.png",
        "icon_toast_success@2x": p+"icon_toast_success@2x-fc1cbdbfa7.png",
        "icon_toast_warn@2x": p+"icon_toast_warn@2x-af934c1f55.png",
        "icon_toast_warn_white@2x": p+"icon_toast_warn_white@2x-8cd90cf423.png",
        "icon_vip_close@2x": p+"icon_vip_close@2x-ac0af9eb57.png",
        "icon_vip_diamond_24x24": p+"icon_vip_diamond_24x24-246173583b.png",
        "im_invite_cn": p+"im_invite_cn-74d6a36705.png",
        "im_invite_en": p+"im_invite_en-ec581dd6b3.png",
        "im_invite_tc": p+"im_invite_tc-c388c465b9.png",
        "ios_b:u@2x": p+"ios_b:u@2x-fa8fe63463.png",
        "ios_bluecursor@2x": p+"ios_bluecursor@2x-17ff569a14.png",
        "ist_blankpage_Passwordprotect@2x": p+"ist_blankpage_Passwordprotect@2x-8546bf9b66.png",
        "ist_blankpage_Phone@2x": p+"ist_blankpage_Phone@2x-5bc80ca80f.png",
        "ist_blankpage_Sharelink2x": p+"ist_blankpage_Sharelink2x-180ca60cb2.png",
        "ist_blankpage_Sharelink@2x": p+"ist_blankpage_Sharelink@2x-12c997df68.png",
        "ist_blankpage_TranslateFailed2x": p+"ist_blankpage_TranslateFailed2x-72097d77d8.png",
        "ist_blankpage_TranslateFailed@2x": p+"ist_blankpage_TranslateFailed@2x-be9bb106a7.png",
        "ist_blankpage_alarm2x": p+"ist_blankpage_alarm2x-238d475853.png",
        "ist_blankpage_alarm@2x": p+"ist_blankpage_alarm@2x-812846ad6a.png",
        "ist_blankpage_authority@2x": p+"ist_blankpage_authority@2x-56ea93c3bf.png",
        "ist_blankpage_delete2x": p+"ist_blankpage_delete2x-db819b637f.png",
        "ist_blankpage_delete@2x": p+"ist_blankpage_delete@2x-98f3c8193a.png",
        "ist_blankpage_edit@2x": p+"ist_blankpage_edit@2x-df0505033a.png",
        "ist_blankpage_group@2x": p+"ist_blankpage_group@2x-b607c1df32.png",
        "ist_blankpage_help2x": p+"ist_blankpage_help2x-84aaeb9c9d.png",
        "ist_blankpage_help@2x": p+"ist_blankpage_help@2x-c33bde26dc.png",
        "ist_blankpage_importfailed2x": p+"ist_blankpage_importfailed2x-b163052694.png",
        "ist_blankpage_importfailed@2x": p+"ist_blankpage_importfailed@2x-68b6a319c2.png",
        "ist_blankpage_importsucessed2x": p+"ist_blankpage_importsucessed2x-5c99edb66d.png",
        "ist_blankpage_importsucessed@2x": p+"ist_blankpage_importsucessed@2x-1ba470d70f.png",
        "ist_blankpage_login@2x": p+"ist_blankpage_login@2x-60024c278f.png",
        "ist_blankpage_nofiles2@2x": p+"ist_blankpage_nofiles2@2x-150e87aa04.png",
        "ist_blankpage_nonotifications@2x": p+"ist_blankpage_nonotifications@2x-c772ecff48.png",
        "ist_blankpage_norecorss2x": p+"ist_blankpage_norecorss2x-708ebe52cc.png",
        "ist_blankpage_nothingfound2x": p+"ist_blankpage_nothingfound2x-e543bb25c7.png",
        "ist_blankpage_nothingfound@2x": p+"ist_blankpage_nothingfound@2x-46a1009955.png",
        "ist_blankpage_offline@2x": p+"ist_blankpage_offline@2x-3891c2a895.png",
        "ist_blankpage_scanbyQQ2x": p+"ist_blankpage_scanbyQQ2x-3a566c64cf.png",
        "ist_blankpage_secondpassword@2x": p+"ist_blankpage_secondpassword@2x-313c9e8461.png",
        "ist_blankpage_sharelinkbroken2x": p+"ist_blankpage_sharelinkbroken2x-3d55c42ec9.png",
        "ist_blankpage_sharelinkbroken@2x": p+"ist_blankpage_sharelinkbroken@2x-8e9542d26f.png",
        "ist_blankpage_starred@2x": p+"ist_blankpage_starred@2x-853167257f.png",
        "ist_blankpage_systemissue2x": p+"ist_blankpage_systemissue2x-d876f3e28d.png",
        "ist_blankpage_systemissue@2x": p+"ist_blankpage_systemissue@2x-e0f19fceed.png",
        "ist_blankpage_wifi@2x": p+"ist_blankpage_wifi@2x-9b0b6df7d5.png",
        "ist_guide_android@2x": p+"ist_guide_android@2x-88c994f676.png",
        "ist_guide_android_h5@2x": p+"ist_guide_android_h5@2x-453e8e3914.png",
        "ist_guide_bg@2x": p+"ist_guide_bg@2x-90ba0cfa2f.png",
        "ist_guide_copylink@2x": p+"ist_guide_copylink@2x-7201d49d98.png",
        "ist_guide_h5@2x": p+"ist_guide_h5@2x-478292c3f3.png",
        "ist_guide_ios@2x": p+"ist_guide_ios@2x-f93baff9d3.png",
        "ist_guide_ios_h5@2x": p+"ist_guide_ios_h5@2x-c2be14129b.png",
        "ist_me_bg@2x": p+"ist_me_bg@2x-0782872974.png",
        "ist_placeholder_formbanner@2x": p+"ist_placeholder_formbanner@2x-2e5d071790.png",
        "ist_placeholder_unpreview@2x": p+"ist_placeholder_unpreview@2x-b654ec3846.png",
        "ist_share_aio@2x": p+"ist_share_aio@2x-1428578738.png",
        "ist_share_doc@2x": p+"ist_share_doc@2x-ea10dab3bc.png",
        "ist_share_doc_local@2x": p+"ist_share_doc_local@2x-bebdc7ba8e.png",
        "ist_share_flowdiagram@2x": p+"ist_share_flowdiagram@2x-4e6408faaf.png",
        "ist_share_flowdiagram_local@2x": p+"ist_share_flowdiagram_local@2x-72155b67d1.png",
        "ist_share_form@2x": p+"ist_share_form@2x-a94f80abf1.png",
        "ist_share_form_local@2x": p+"ist_share_form_local@2x-eb569739ef.png",
        "ist_share_image@2x": p+"ist_share_image@2x-4530c7234d.png",
        "ist_share_mindmap@2x": p+"ist_share_mindmap@2x-7a18f7c035.png",
        "ist_share_mindmap_local@2x": p+"ist_share_mindmap_local@2x-93751d789f.png",
        "ist_share_mp3@2x": p+"ist_share_mp3@2x-2e25fa42cb.png",
        "ist_share_mp4@2x": p+"ist_share_mp4@2x-c8c494cf3e.png",
        "ist_share_pdf@2x": p+"ist_share_pdf@2x-46bef0c140.png",
        "ist_share_pdf_local@2x": p+"ist_share_pdf_local@2x-b1a7ef3908.png",
        "ist_share_sheet@2x": p+"ist_share_sheet@2x-097fd371a6.png",
        "ist_share_sheet_local@2x": p+"ist_share_sheet_local@2x-0f0a7b50e0.png",
        "ist_share_slide@2x": p+"ist_share_slide@2x-8a1670d990.png",
        "ist_share_slide_local@2x": p+"ist_share_slide_local@2x-5667b12a84.png",
        "ist_share_smartsheet_local@2x": p+"ist_share_smartsheet_local@2x-8501955107.png",
        "ist_splash_cn": p+"ist_splash_cn-5be8a35a89.png",
        "ist_splash_en": p+"ist_splash_en-657c935c8b.png",
        "ist_splash_zh-tc": p+"ist_splash_zh-tc-7c1fc40210.png",
        "ist_to_miniprogram@2x": p+"ist_to_miniprogram@2x-dfe1c2f846.png",
        "ist_to_sharefolder@2x": p+"ist_to_sharefolder@2x-c281b66642.png",
        "list_template_nor@2x": p+"list_template_nor@2x-7ce842aca9.png",
        "list_template_sel@2x": p+"list_template_sel@2x-5427859570.png",
        "location_fill_24@2x": p+"location_fill_24@2x-18c3548baf.png",
        "login_qq@2x": p+"login_qq@2x-898af29fda.png",
        "login_scan@2x": p+"login_scan@2x-63df36f7a1.png",
        "login_wechat@2x": p+"login_wechat@2x-d61972c86d.png",
        "login_wechatwork@2x": p+"login_wechatwork@2x-63075ed88f.png",
        "logo_80@2x": p+"logo_80@2x-a42dcd0613.png",
        "longpress_add_list_copy@2x": p+"longpress_add_list_copy@2x-997e1a93e9.png",
        "longpress_add_list_cut@2x": p+"longpress_add_list_cut@2x-554801ddf4.png",
        "longpress_add_row_copy@2x": p+"longpress_add_row_copy@2x-bc09f634b5.png",
        "longpress_add_row_cut@2x": p+"longpress_add_row_cut@2x-26cadd9581.png",
        "longpress_add_row_list@2x": p+"longpress_add_row_list@2x-517bb19622.png",
        "longpress_call@2x": p+"longpress_call@2x-2a3ff73f2e.png",
        "longpress_card@2x": p+"longpress_card@2x-23265299bd.png",
        "longpress_cellphoto@2x": p+"longpress_cellphoto@2x-43535d161b.png",
        "longpress_crop_image@2x": p+"longpress_crop_image@2x-98c02774cd.png",
        "longpress_dele@2x": p+"longpress_dele@2x-14031cb1bc.png",
        "longpress_delelink@2x": p+"longpress_delelink@2x-480abe0276.png",
        "longpress_email@2x": p+"longpress_email@2x-15a8da6357.png",
        "longpress_fill@2x": p+"longpress_fill@2x-fca8be70f2.png",
        "longpress_floatingphoto_24@2x": p+"longpress_floatingphoto_24@2x-e263e8f236.png",
        "longpress_freezecell@2x": p+"longpress_freezecell@2x-4870c2bec2.png",
        "longpress_freezecell_cancel@2x": p+"longpress_freezecell_cancel@2x-dab5809e7d.png",
        "longpress_fullscreen@2x": p+"longpress_fullscreen@2x-645997602c.png",
        "longpress_icon_@@2x": p+"longpress_icon_@@2x-283acc3c2f.png",
        "longpress_icon_biu@2x": p+"longpress_icon_biu@2x-29a1f56a4a.png",
        "longpress_icon_clearformat@2x": p+"longpress_icon_clearformat@2x-6486b4fd09.png",
        "longpress_icon_comment@2x": p+"longpress_icon_comment@2x-b57e3edfbc.png",
        "longpress_icon_copy@2x": p+"longpress_icon_copy@2x-856d00ccdb.png",
        "longpress_icon_copylink@2x": p+"longpress_icon_copylink@2x-4955771e27.png",
        "longpress_icon_cut@2x": p+"longpress_icon_cut@2x-98701e8e68.png",
        "longpress_icon_edit@2x": p+"longpress_icon_edit@2x-111a8ceb85.png",
        "longpress_icon_fold@2x": p+"longpress_icon_fold@2x-7e72f6e979.png",
        "longpress_icon_forward@2x": p+"longpress_icon_forward@2x-dd857b39ad.png",
        "longpress_icon_link@2x": p+"longpress_icon_link@2x-c806f8253c.png",
        "longpress_icon_link_card@2x": p+"longpress_icon_link_card@2x-477b791fb2.png",
        "longpress_icon_link_icon@2x": p+"longpress_icon_link_icon@2x-eda1a93dcf.png",
        "longpress_icon_link_preview@2x": p+"longpress_icon_link_preview@2x-dcd49a521e.png",
        "longpress_icon_moveback@2x": p+"longpress_icon_moveback@2x-179bcc726e.png",
        "longpress_icon_moveforward@2x": p+"longpress_icon_moveforward@2x-dff604834e.png",
        "longpress_icon_multiselect@2x": p+"longpress_icon_multiselect@2x-a39ebefe6e.png",
        "longpress_icon_paste@2x": p+"longpress_icon_paste@2x-49d1c44b47.png",
        "longpress_icon_remind@2x": p+"longpress_icon_remind@2x-862b1106fc.png",
        "longpress_icon_scan@2x": p+"longpress_icon_scan@2x-395a2fb3f1.png",
        "longpress_icon_selecttext@2x": p+"longpress_icon_selecttext@2x-fcf41d6418.png",
        "longpress_icon_signature_redo@2x": p+"longpress_icon_signature_redo@2x-b14a5c0820.png",
        "longpress_icon_unfold@2x": p+"longpress_icon_unfold@2x-c864401c6b.png",
        "longpress_image_view@2x": p+"longpress_image_view@2x-8b78e6ce9c.png",
        "longpress_insert_link@2x": p+"longpress_insert_link@2x-ef1b991e73.png",
        "longpress_list_copy@2x": p+"longpress_list_copy@2x-997e1a93e9.png",
        "longpress_list_cut@2x": p+"longpress_list_cut@2x-554801ddf4.png",
        "longpress_list_delete@2x": p+"longpress_list_delete@2x-0d9bf49064.png",
        "longpress_mergecells@2x": p+"longpress_mergecells@2x-a0e0c782ba.png",
        "longpress_mergecells_cancel@2x": p+"longpress_mergecells_cancel@2x-2e6fda236a.png",
        "longpress_photo@2x": p+"longpress_photo@2x-c613ba7f85.png",
        "longpress_quicktools_24@2x": p+"longpress_quicktools_24@2x-dc1630968e.png",
        "longpress_replacephoto@2x": p+"longpress_replacephoto@2x-2db6d2de06.png",
        "longpress_rotate_customize@2x": p+"longpress_rotate_customize@2x-d24f2a541c.png",
        "longpress_rotate_image@2x": p+"longpress_rotate_image@2x-771aa7297f.png",
        "longpress_row+line_adddown@2x": p+"longpress_row+line_adddown@2x-b1dbd4aad4.png",
        "longpress_row+line_addleft@2x": p+"longpress_row+line_addleft@2x-4e3418b703.png",
        "longpress_row+line_addright@2x": p+"longpress_row+line_addright@2x-ca4c687a9b.png",
        "longpress_row+line_addup@2x": p+"longpress_row+line_addup@2x-4c351875f6.png",
        "longpress_row_delete@2x": p+"longpress_row_delete@2x-9cb1ac92d8.png",
        "longpress_selectpart@2x": p+"longpress_selectpart@2x-06620b2540.png",
        "longpress_text_highlight@2x": p+"longpress_text_highlight@2x-9229952f59.png",
        "longpress_text_highlight_cancel@2x": p+"longpress_text_highlight_cancel@2x-e8a0fb2aa5.png",
        "longpress_todo@2x": p+"longpress_todo@2x-0e1fda8bdd.png",
        "longpress_view@2x": p+"longpress_view@2x-fb9d8b185b.png",
        "menu__officalcertification@2x": p+"menu__officalcertification@2x-8922866127.png",
        "menu_add@2x": p+"menu_add@2x-b983e9c5b8.png",
        "menu_addto@2x": p+"menu_addto@2x-d964c49c35.png",
        "menu_authority@2x": p+"menu_authority@2x-8b8d9006b6.png",
        "menu_bwechat@2x": p+"menu_bwechat@2x-2c2ad75f5c.png",
        "menu_cache@2x": p+"menu_cache@2x-262ae3f54e.png",
        "menu_cache__succeed@2x": p+"menu_cache__succeed@2x-4aec7c378e.png",
        "menu_cache_cancel@2x": p+"menu_cache_cancel@2x-88d14d650a.png",
        "menu_cache_download @2x": p+"menu_cache_download @2x-c822336490.png",
        "menu_cache_upload@2x": p+"menu_cache_upload@2x-eebf6ddff9.png",
        "menu_camera@2x": p+"menu_camera@2x-bfc19c2f25.png",
        "menu_catalog@2x": p+"menu_catalog@2x-23ef2d5225.png",
        "menu_checkform@2x": p+"menu_checkform@2x-e9e6c0a06c.png",
        "menu_copy@2x": p+"menu_copy@2x-edfc024252.png",
        "menu_creatform@2x": p+"menu_creatform@2x-0af04a4522.png",
        "menu_data_appendix@2x": p+"menu_data_appendix@2x-5e1cd1120d.png",
        "menu_data_checkbox@2x": p+"menu_data_checkbox@2x-148cc79448.png",
        "menu_data_contact@2x": p+"menu_data_contact@2x-21893eb2a6.png",
        "menu_data_date31@2x": p+"menu_data_date31@2x-d31eb9f127.png",
        "menu_data_dropdown@2x": p+"menu_data_dropdown@2x-2e0db38911.png",
        "menu_data_email@2x": p+"menu_data_email@2x-28120f3483.png",
        "menu_data_idcard@2x": p+"menu_data_idcard@2x-e5dc80f8c1.png",
        "menu_data_none@2x": p+"menu_data_none@2x-14497158f9.png",
        "menu_data_number@2x": p+"menu_data_number@2x-fefbb68796.png",
        "menu_data_phonenumber@2x": p+"menu_data_phonenumber@2x-8c5dd2740f.png",
        "menu_data_progress@2x": p+"menu_data_progress@2x-bf9bd3bd80.png",
        "menu_data_star@2x": p+"menu_data_star@2x-ff49a0b899.png",
        "menu_data_telephonenumber@2x": p+"menu_data_telephonenumber@2x-8517b5e616.png",
        "menu_data_temperature@2x": p+"menu_data_temperature@2x-f3cba4f10b.png",
        "menu_data_text@2x": p+"menu_data_text@2x-dad369a850.png",
        "menu_find+replace@2x": p+"menu_find+replace@2x-7931f77551.png",
        "menu_history@2x": p+"menu_history@2x-60623dad0d.png",
        "menu_icon_link@2x": p+"menu_icon_link@2x-d9dba70675.png",
        "menu_icon_tencentdoc@2x": p+"menu_icon_tencentdoc@2x-4ae559d054.png",
        "menu_image@2x": p+"menu_image@2x-18e05063bc.png",
        "menu_link_card@2x 2": p+"menu_link_card@2x 2-cfe2ce3316.png",
        "menu_link_card@2x": p+"menu_link_card@2x-cfe2ce3316.png",
        "menu_link_fontlink@2x 2": p+"menu_link_fontlink@2x 2-908632a739.png",
        "menu_link_fontlink@2x": p+"menu_link_fontlink@2x-45c101ce1f.png",
        "menu_link_iconlink@2x 2": p+"menu_link_iconlink@2x 2-01518df336.png",
        "menu_link_iconlink@2x": p+"menu_link_iconlink@2x-01518df336.png",
        "menu_link_preview@2x 2": p+"menu_link_preview@2x 2-7f42f51454.png",
        "menu_link_preview@2x": p+"menu_link_preview@2x-7f42f51454.png",
        "menu_linkexcel@2x": p+"menu_linkexcel@2x-52d27fac0b.png",
        "menu_linkform@2x": p+"menu_linkform@2x-bb7420f626.png",
        "menu_moveto@2x": p+"menu_moveto@2x-f4fd7d2baf.png",
        "menu_notice_mine@2x": p+"menu_notice_mine@2x-93f161f433.png",
        "menu_quickway@2x": p+"menu_quickway@2x-1e9cbcf3e2.png",
        "menu_quickway_cancel@2x": p+"menu_quickway_cancel@2x-c9f6e214eb.png",
        "menu_reback@2x": p+"menu_reback@2x-9d5759817b.png",
        "menu_rename@2x": p+"menu_rename@2x-28f622ad04.png",
        "menu_revisionhistory@2x": p+"menu_revisionhistory@2x-38be780585.png",
        "menu_scan@2x": p+"menu_scan@2x-c99b60e7cc.png",
        "menu_search@2x": p+"menu_search@2x-730b2acf14.png",
        "menu_to_computer@2x": p+"menu_to_computer@2x-50a1f04fc8.png",
        "menu_to_excel@2x": p+"menu_to_excel@2x-0a83b5fb72.png",
        "menu_to_pdf@2x": p+"menu_to_pdf@2x-6acd33ee91.png",
        "menu_to_photo@2x": p+"menu_to_photo@2x-8671b28b45.png",
        "menu_to_ppt@2x": p+"menu_to_ppt@2x-cda8e2f6e9.png",
        "menu_to_word@2x": p+"menu_to_word@2x-11fbd452cd.png",
        "menu_transfer@2x": p+"menu_transfer@2x-4ed8097068.png",
        "menu_unlinkform@2x": p+"menu_unlinkform@2x-0a890f3388.png",
        "menu_uploadfile@2x": p+"menu_uploadfile@2x-1b27d4c230.png",
        "menu_viewswitch@2x": p+"menu_viewswitch@2x-fe636be9e4.png",
        "menu_waitinginvitation@2x": p+"menu_waitinginvitation@2x-b46645b46d.png",
        "menu_weipan@2x": p+"menu_weipan@2x-e57dc5e263.png",
        "mini_programs_01@2x": p+"mini_programs_01@2x-707662a82d.png",
        "mini_programs_02@2x": p+"mini_programs_02@2x-a02f5435dc.png",
        "mobile_buy_tag@2x": p+"mobile_buy_tag@2x-7dcf0308a2.png",
        "mobile_free_tag@2x": p+"mobile_free_tag@2x-cbbe0ac78b.png",
        "more_jielong@2x": p+"more_jielong@2x-030a02d03a.png",
        "more_settings_disable@2x": p+"more_settings_disable@2x-f032680425.png",
        "more_settings_normal@2x": p+"more_settings_normal@2x-f0337c0207.png",
        "navigation_OCR@2x": p+"navigation_OCR@2x-7977f22193.png",
        "navigation_back@2x": p+"navigation_back@2x-df44415163.png",
        "navigation_back_white@2x": p+"navigation_back_white@2x-bc20cf97dd.png",
        "navigation_backup@2x": p+"navigation_backup@2x-d10cb372c3.png",
        "navigation_download@2x": p+"navigation_download@2x-c3b61e5aa7.png",
        "navigation_edit@2x": p+"navigation_edit@2x-6038512127.png",
        "navigation_emoji@2x": p+"navigation_emoji@2x-27ca837fd2.png",
        "navigation_error@2x": p+"navigation_error@2x-ccc649a063.png",
        "navigation_expand@2x": p+"navigation_expand@2x-eda64fee06.png",
        "navigation_fit_paper@2x": p+"navigation_fit_paper@2x-769695ff43.png",
        "navigation_fit_screen@2x": p+"navigation_fit_screen@2x-4dfb7fd291.png",
        "navigation_fraction@2x": p+"navigation_fraction@2x-a70d70f11a.png",
        "navigation_headline1@2x": p+"navigation_headline1@2x-9ca71ccf1e.png",
        "navigation_headline2@2x": p+"navigation_headline2@2x-0f165c85a5.png",
        "navigation_headline3@2x": p+"navigation_headline3@2x-79b2fd6ea4.png",
        "navigation_headline4@2x": p+"navigation_headline4@2x-7a6448317b.png",
        "navigation_headline5@2x": p+"navigation_headline5@2x-1a2079214b.png",
        "navigation_headline6@2x": p+"navigation_headline6@2x-c08ac75a27.png",
        "navigation_headline@2x": p+"navigation_headline@2x-037719c006.png",
        "navigation_home@2x": p+"navigation_home@2x-a039316cb3.png",
        "navigation_more@2x": p+"navigation_more@2x-d1c67dbe1d.png",
        "navigation_notice@2x": p+"navigation_notice@2x-6f149fc426.png",
        "navigation_officalcertification@2x": p+"navigation_officalcertification@2x-5cff76ffea.png",
        "navigation_pdf@2x": p+"navigation_pdf@2x-cc690c53d6.png",
        "navigation_play@2x": p+"navigation_play@2x-c013e2b293.png",
        "navigation_search@2x": p+"navigation_search@2x-398658c752.png",
        "navigation_share@2x": p+"navigation_share@2x-8b3cfeb3f9.png",
        "navigation_share_white@2x": p+"navigation_share_white@2x-f77d701d2b.png",
        "navigation_star@2x": p+"navigation_star@2x-cfb6133b4b.png",
        "navigation_star_fill@2x": p+"navigation_star_fill@2x-6076df2622.png",
        "navigation_test@2x": p+"navigation_test@2x-e2fc0aa875.png",
        "navigation_threecolumns@2x": p+"navigation_threecolumns@2x-fa6940bca0.png",
        "navigation_topic@2x": p+"navigation_topic@2x-1d173b5b58.png",
        "navigation_twocolumns@2x": p+"navigation_twocolumns@2x-83a50256fa.png",
        "navigation_upload_regular_24@2x": p+"navigation_upload_regular_24@2x-1115dce544.png",
        "navigation_voicenotes@2x": p+"navigation_voicenotes@2x-cc0343e0d1.png",
        "navigation_wifi@2x": p+"navigation_wifi@2x-c170a0821e.png",
        "navigation_wifi_gray_24@2x": p+"navigation_wifi_gray_24@2x-586f2e3e4c.png",
        "pc_introduction@2x": p+"pc_introduction@2x-8ca6af7100.png",
        "plugin_outline_regular_24@2x": p+"plugin_outline_regular_24@2x-21389c9cc2.png",
        "qr_logo@2x": p+"qr_logo@2x-b34609cea2.png",
        "qr_logo_bg@2x": p+"qr_logo_bg@2x-566399967e.png",
        "qr_logo_sticker@2x": p+"qr_logo_sticker@2x-02e2c124bb.png",
        "question_ deadline@2x": p+"question_ deadline@2x-d33c0d8d9d.png",
        "question_ roster@2x": p+"question_ roster@2x-519aa8a0c8.png",
        "question_add_blue@2x": p+"question_add_blue@2x-f7a0b822f8.png",
        "question_add_disable@2x": p+"question_add_disable@2x-e61f520e66.png",
        "question_add_grey@2x": p+"question_add_grey@2x-3c8fa0fa57.png",
        "question_checkbox_nor@2x": p+"question_checkbox_nor@2x-7c7e67a5ac.png",
        "question_checkbox_nor_dis@2x": p+"question_checkbox_nor_dis@2x-dcad9e230b.png",
        "question_checkbox_sel@2x": p+"question_checkbox_sel@2x-dc4a1c2eaa.png",
        "question_checkbox_sel_dis@2x": p+"question_checkbox_sel_dis@2x-f26ca6bcdc.png",
        "question_correct@2x": p+"question_correct@2x-bfa9727db5.png",
        "question_date@2x": p+"question_date@2x-f055bc3ab6.png",
        "question_date_disable@2x": p+"question_date_disable@2x-2cbb0ef3d3.png",
        "question_delete_normal@2x": p+"question_delete_normal@2x-6f6d374974.png",
        "question_drag_button@2x": p+"question_drag_button@2x-c692136140.png",
        "question_error@2x": p+"question_error@2x-1f3ee63957.png",
        "question_fraction@2x": p+"question_fraction@2x-1bef652588.png",
        "question_location@2x": p+"question_location@2x-77c8266aea.png",
        "question_location_dis@2x": p+"question_location_dis@2x-4c68838301.png",
        "question_location_disable@2x": p+"question_location_disable@2x-f1608aee88.png",
        "question_position@2x": p+"question_position@2x-33b4bea80e.png",
        "question_radio_nor@2x": p+"question_radio_nor@2x-083d6d94fa.png",
        "question_radio_nor_dis@2x": p+"question_radio_nor_dis@2x-c60e21e579.png",
        "question_radio_sel@2x": p+"question_radio_sel@2x-3b29b1524c.png",
        "question_radio_sel_dis@2x": p+"question_radio_sel_dis@2x-b957ad2fd4.png",
        "question_remove_dis@2x": p+"question_remove_dis@2x-f07da1149f.png",
        "question_remove_nor@2x": p+"question_remove_nor@2x-22b58db637.png",
        "question_roster@2x": p+"question_roster@2x-db3b39182e.png",
        "question_set_drag@2x": p+"question_set_drag@2x-26668fe70a.png",
        "question_set_end@2x": p+"question_set_end@2x-98bab047c8.png",
        "question_set_pause@2x": p+"question_set_pause@2x-1230864ede.png",
        "question_set_play@2x": p+"question_set_play@2x-249ca28c03.png",
        "question_set_required@2x": p+"question_set_required@2x-e2fabd8ea2.png",
        "question_set_roster@2x": p+"question_set_roster@2x-7711d354df.png",
        "question_set_score@2x": p+"question_set_score@2x-20ba2c8718.png",
        "question_set_smalladd@2x": p+"question_set_smalladd@2x-08e1e90b26.png",
        "question_set_smallcheckbox_nor@2x": p+"question_set_smallcheckbox_nor@2x-645cd1f992.png",
        "question_set_smallcheckbox_sel@2x": p+"question_set_smallcheckbox_sel@2x-1fa8ed93aa.png",
        "question_set_statustag@2x": p+"question_set_statustag@2x-4be311d797.png",
        "question_set_time@2x": p+"question_set_time@2x-402aca0bd2.png",
        "question_set_unstart@2x": p+"question_set_unstart@2x-b8788bdf6b.png",
        "question_submitted@2x": p+"question_submitted@2x-21612d24ff.png",
        "question_temperature_c@2x": p+"question_temperature_c@2x-cfbf5d6934.png",
        "question_temperature_c_dis@2x": p+"question_temperature_c_dis@2x-60d3771c8d.png",
        "question_temperature_f@2x": p+"question_temperature_f@2x-ea5bbf4dcc.png",
        "question_temperature_f_dis@2x": p+"question_temperature_f_dis@2x-476b8f494a.png",
        "question_time@2x": p+"question_time@2x-0179f87249.png",
        "question_time_dis@2x": p+"question_time_dis@2x-32b539c117.png",
        "question_time_disable@2x": p+"question_time_disable@2x-3bc9119450.png",
        "questiontype_checkbox@2x": p+"questiontype_checkbox@2x-536d07809d.png",
        "questiontype_checkbox_b@2x": p+"questiontype_checkbox_b@2x-16d78cbdff.png",
        "questiontype_copy_normal@2x": p+"questiontype_copy_normal@2x-604f01d13e.png",
        "questiontype_date@2x": p+"questiontype_date@2x-3e2c87c629.png",
        "questiontype_file@2x": p+"questiontype_file@2x-a9e2b1cc87.png",
        "questiontype_file_b@2x": p+"questiontype_file_b@2x-ffb3fc8adb.png",
        "questiontype_fill-in_28@2x": p+"questiontype_fill-in_28@2x-8e2616388d.png",
        "questiontype_image@2x": p+"questiontype_image@2x-df4ebcfbbe.png",
        "questiontype_image_b@2x": p+"questiontype_image_b@2x-8a7cb55cc2.png",
        "questiontype_location@2x": p+"questiontype_location@2x-64e3e30c45.png",
        "questiontype_location_b@2x": p+"questiontype_location_b@2x-415dcfbeac.png",
        "questiontype_matrix_28@2x": p+"questiontype_matrix_28@2x-53f0f58db7.png",
        "questiontype_multileveloptions_28@2x": p+"questiontype_multileveloptions_28@2x-95c7514ba4.png",
        "questiontype_radio@2x": p+"questiontype_radio@2x-6e405c95c9.png",
        "questiontype_radio_b@2x": p+"questiontype_radio_b@2x-f1a090c3fc.png",
        "questiontype_rate_28@2x": p+"questiontype_rate_28@2x-9592b85d95.png",
        "questiontype_scanning_28@2x": p+"questiontype_scanning_28@2x-40cae7af9d.png",
        "questiontype_select@2x": p+"questiontype_select@2x-2038a67b53.png",
        "questiontype_select_b@2x": p+"questiontype_select_b@2x-1afa079e44.png",
        "questiontype_signature@2x": p+"questiontype_signature@2x-384fc93d6c.png",
        "questiontype_signature_b@2x": p+"questiontype_signature_b@2x-8b33130443.png",
        "questiontype_simple@2x": p+"questiontype_simple@2x-641b8878e8.png",
        "questiontype_simple_b@2x": p+"questiontype_simple_b@2x-10381ceaeb.png",
        "questiontype_sorting_28@2x": p+"questiontype_sorting_28@2x-d7d1775420.png",
        "questiontype_star_28@2x": p+"questiontype_star_28@2x-cb231cb1d4.png",
        "questiontype_temperature@2x": p+"questiontype_temperature@2x-014c68a4da.png",
        "questiontype_temperature_b@2x": p+"questiontype_temperature_b@2x-6be74a1e75.png",
        "questiontype_time@2x": p+"questiontype_time@2x-ea863fd663.png",
        "questiontype_time_b@2x": p+"questiontype_time_b@2x-8b60c99c4d.png",
        "radiobutton-disable-210114@2x": p+"radiobutton-disable-210114@2x-8ac4f5b409.png",
        "radiobutton-selected-210114@2x": p+"radiobutton-selected-210114@2x-3b29b1524c.png",
        "radiobutton-unselected-210114@2x": p+"radiobutton-unselected-210114@2x-083d6d94fa.png",
        "scan_24@2x": p+"scan_24@2x-eced543436.png",
        "scanning_album@2x": p+"scanning_album@2x-9bf66db823.png",
        "scanning_cut@2x": p+"scanning_cut@2x-dd6f73f775.png",
        "scanning_filter@2x": p+"scanning_filter@2x-9acd9d7618.png",
        "scanning_filter_active@2x": p+"scanning_filter_active@2x-6d53919856.png",
        "scanning_loading2x": p+"scanning_loading2x-a072a6ee48.png",
        "scanning_motion@2x": p+"scanning_motion@2x-02ca1375fe.png",
        "scanning_ocr@2x": p+"scanning_ocr@2x-9ef567b6c4.png",
        "scanning_reback_black@2x": p+"scanning_reback_black@2x-662f336fe7.png",
        "scanning_reback_white@2x": p+"scanning_reback_white@2x-735993352d.png",
        "scanning_rotate@2x": p+"scanning_rotate@2x-9dfd9a5627.png",
        "scanning_shooting@2x": p+"scanning_shooting@2x-53f0f3365e.png",
        "secondary_comment_blue@2x": p+"secondary_comment_blue@2x-07e7f1cf5f.png",
        "secondary_comment_grey@2x": p+"secondary_comment_grey@2x-d7f7e682a7.png",
        "segmented_view_grid@2x": p+"segmented_view_grid@2x-682a62bb60.png",
        "segmented_view_list@2x": p+"segmented_view_list@2x-effab033ae.png",
        "select_avatar@2x": p+"select_avatar@2x-5bb841b6ac.png",
        "set-score-add@2x": p+"set-score-add@2x-5db96c5fd6.png",
        "set-score-sub@2x": p+"set-score-sub@2x-01169a0938.png",
        "set_notify_me@2x": p+"set_notify_me@2x-76b00c2461.png",
        "set_score@2x": p+"set_score@2x-a3228c0858.png",
        "shape_fill_regular_28@2x": p+"shape_fill_regular_28@2x-4465fe29c8.png",
        "square-checkbox-disable-210114@2x": p+"square-checkbox-disable-210114@2x-77526a3095.png",
        "square-checkbox-selected-210114@2x": p+"square-checkbox-selected-210114@2x-87c2eeebc1.png",
        "square-checkbox-unselected-210114@2x": p+"square-checkbox-unselected-210114@2x-7c7e67a5ac.png",
        "stafflist_outline_regular_24@2x": p+"stafflist_outline_regular_24@2x-d5cda4325e.png",
        "star-fill-48@2x": p+"star-fill-48@2x-51b7807cfb.png",
        "star-unfill-48@2x": p+"star-unfill-48@2x-044a3d44cd.png",
        "star-unfill@2x": p+"star-unfill@2x-9036eea396.png",
        "super_vip_diamond_normal@2x": p+"super_vip_diamond_normal@2x-4303712363.png",
        "svip+vip_card_disable_en@2x": p+"svip+vip_card_disable_en@2x-7d00fb929b.png",
        "svip+vip_card_disable_tc@2x": p+"svip+vip_card_disable_tc@2x-8a83690a32.png",
        "svip+vip_card_expired_en@2x": p+"svip+vip_card_expired_en@2x-9743ce2f8c.png",
        "svip+vip_card_expired_tc@2x": p+"svip+vip_card_expired_tc@2x-5aeccdb61d.png",
        "svip+vip_smalldiamond_disable@2x": p+"svip+vip_smalldiamond_disable@2x-d455c6e15d.png",
        "svip_smalldiamond_normal@2x": p+"svip_smalldiamond_normal@2x-26ef0fe6f1.png",
        "svip_tag@2x": p+"svip_tag@2x-bb68e39f57.png",
        "switch_off@2x": p+"switch_off@2x-3e72813dfb.png",
        "switch_on@2x": p+"switch_on@2x-760dd8b581.png",
        "tabbar_creat@2x": p+"tabbar_creat@2x-9bbf2038c1.png",
        "tabbar_doc_nor@2x": p+"tabbar_doc_nor@2x-4d77150f23.png",
        "tabbar_doc_sel@2x": p+"tabbar_doc_sel@2x-d2054c229b.png",
        "tabbar_home_nor@2x": p+"tabbar_home_nor@2x-81a65b8f84.png",
        "tabbar_home_sel@2x": p+"tabbar_home_sel@2x-54260e3f52.png",
        "tabbar_me_nor@2x": p+"tabbar_me_nor@2x-9cf6216fd1.png",
        "tabbar_me_sel@2x": p+"tabbar_me_sel@2x-6d185258e4.png",
        "tabbar_tool_nor_24@2x": p+"tabbar_tool_nor_24@2x-eab89f43db.png",
        "tabbar_tool_sel_24@2x": p+"tabbar_tool_sel_24@2x-8e117ade4a.png",
        "templates_background_620@2x": p+"templates_background_620@2x-f18a8deff6.png",
        "text@2x": p+"text@2x-1b850bcba3.png",
        "textbox_fill_regular_28@2x": p+"textbox_fill_regular_28@2x-b1a6782ce3.png",
        "tick_sel@2x": p+"tick_sel@2x-eb49934999.png",
        "tick_unsel@2x": p+"tick_unsel@2x-a88ccaa345.png",
        "tips_banner_officialaccountsA@2x": p+"tips_banner_officialaccountsA@2x-3ad9cde9b0.png",
        "tips_banner_officialaccountsB@2x": p+"tips_banner_officialaccountsB@2x-0f923dc2a8.png",
        "tips_banner_qq@2x": p+"tips_banner_qq@2x-73047e4355.png",
        "tips_banner_starred@2x": p+"tips_banner_starred@2x-9a1eee8c0c.png",
        "tips_banner_vip@2x": p+"tips_banner_vip@2x-23e10bb8c8.png",
        "tips_banner_wechat@2x": p+"tips_banner_wechat@2x-96647bf996.png",
        "titlebar_form@2x": p+"titlebar_form@2x-62077755f1.png",
        "titlebar_preview@2x": p+"titlebar_preview@2x-7050286e98.png",
        "titlebar_qrcode@2x": p+"titlebar_qrcode@2x-ec60643a06.png",
        "titlebar_xiezuoren@2x": p+"titlebar_xiezuoren@2x-c5efdec138.png",
        "toolbar_@@2x": p+"toolbar_@@2x-7ce413155e.png",
        "toolbar_add@2x": p+"toolbar_add@2x-a1661deb20.png",
        "toolbar_add_@@2x": p+"toolbar_add_@@2x-42881d0409.png",
        "toolbar_add_camera@2x": p+"toolbar_add_camera@2x-ad8576d83f.png",
        "toolbar_add_cellphoto@2x": p+"toolbar_add_cellphoto@2x-6b08db9bc6.png",
        "toolbar_add_clock@2x": p+"toolbar_add_clock@2x-ae60b840d8.png",
        "toolbar_add_comment@2x": p+"toolbar_add_comment@2x-609e2e7f0a.png",
        "toolbar_add_divide@2x": p+"toolbar_add_divide@2x-3a30a21bfe.png",
        "toolbar_add_docs@2x": p+"toolbar_add_docs@2x-b49a36217c.png",
        "toolbar_add_folder@2x": p+"toolbar_add_folder@2x-7247638881.png",
        "toolbar_add_function@2x": p+"toolbar_add_function@2x-552094c9fc.png",
        "toolbar_add_link@2x": p+"toolbar_add_link@2x-f091604e7f.png",
        "toolbar_add_list@2x": p+"toolbar_add_list@2x-04ec188e82.png",
        "toolbar_add_location@2x": p+"toolbar_add_location@2x-d7167ac86f.png",
        "toolbar_add_ocr@2x": p+"toolbar_add_ocr@2x-66f0a34450.png",
        "toolbar_add_photo@2x": p+"toolbar_add_photo@2x-2009a430af.png",
        "toolbar_add_recording@2x": p+"toolbar_add_recording@2x-4013d0514a.png",
        "toolbar_add_signature@2x": p+"toolbar_add_signature@2x-b520e401b9.png",
        "toolbar_add_table@2x": p+"toolbar_add_table@2x-2e50aad585.png",
        "toolbar_add_template_daily@2x": p+"toolbar_add_template_daily@2x-1cd06c905c.png",
        "toolbar_add_template_report@2x": p+"toolbar_add_template_report@2x-598834801f.png",
        "toolbar_add_template_todo@2x": p+"toolbar_add_template_todo@2x-d8680ebc25.png",
        "toolbar_add_weipan@2x": p+"toolbar_add_weipan@2x-f195f59561.png",
        "toolbar_camera@2x": p+"toolbar_camera@2x-4567d94f99.png",
        "toolbar_cancelremarks@2x": p+"toolbar_cancelremarks@2x-220aaf6d42.png",
        "toolbar_card@2x": p+"toolbar_card@2x-0417b9df99.png",
        "toolbar_cell@2x": p+"toolbar_cell@2x-4e941c282b.png",
        "toolbar_cell_allborder@2x": p+"toolbar_cell_allborder@2x-36ea2f9a0e.png",
        "toolbar_cell_decreasedecimal@2x": p+"toolbar_cell_decreasedecimal@2x-652272a69b.png",
        "toolbar_cell_horizontalborder@2x": p+"toolbar_cell_horizontalborder@2x-d1f9a9f4e5.png",
        "toolbar_cell_increasedecimal@2x": p+"toolbar_cell_increasedecimal@2x-7828680f79.png",
        "toolbar_cell_innerborder@2x": p+"toolbar_cell_innerborder@2x-8f5d442328.png",
        "toolbar_cell_noborder@2x": p+"toolbar_cell_noborder@2x-6d02063e23.png",
        "toolbar_cell_outborder@2x": p+"toolbar_cell_outborder@2x-e3ecfb2b2f.png",
        "toolbar_cell_rightcell@2x": p+"toolbar_cell_rightcell@2x-576bde4713.png",
        "toolbar_cell_select@2x": p+"toolbar_cell_select@2x-066417ba1d.png",
        "toolbar_cell_upcell@2x": p+"toolbar_cell_upcell@2x-7b3fcd5a4b.png",
        "toolbar_cell_verticalborder@2x": p+"toolbar_cell_verticalborder@2x-5035cb2b91.png",
        "toolbar_clock@2x": p+"toolbar_clock@2x-2bc46bc4ab.png",
        "toolbar_close@2x": p+"toolbar_close@2x-74326d3b7a.png",
        "toolbar_collapse_24@2x": p+"toolbar_collapse_24@2x-ffc52a86b0.png",
        "toolbar_docs@2x": p+"toolbar_docs@2x-7648d8714f.png",
        "toolbar_fil_by_line@2x": p+"toolbar_fil_by_line@2x-d07067406e.png",
        "toolbar_file@2x": p+"toolbar_file@2x-3ffe5ebc66.png",
        "toolbar_fileconversion@2x": p+"toolbar_fileconversion@2x-71c6592b59.png",
        "toolbar_filter@2x": p+"toolbar_filter@2x-cf74f7fb97.png",
        "toolbar_filter_selected@2x": p+"toolbar_filter_selected@2x-1aaff7e626.png",
        "toolbar_forward@2x": p+"toolbar_forward@2x-b5bb9e0903.png",
        "toolbar_function@2x": p+"toolbar_function@2x-713b6d8998.png",
        "toolbar_highlight@2x": p+"toolbar_highlight@2x-eb6ecf88c7.png",
        "toolbar_information@2x": p+"toolbar_information@2x-88687ff3f5.png",
        "toolbar_keyboard_off@2x": p+"toolbar_keyboard_off@2x-b59d62f7ff.png",
        "toolbar_keyboard_on@2x": p+"toolbar_keyboard_on@2x-4c6e9483ea.png",
        "toolbar_link@2x": p+"toolbar_link@2x-ddaa3826ea.png",
        "toolbar_mergecells@2x": p+"toolbar_mergecells@2x-76356e91c4.png",
        "toolbar_openlocalfile_24@2x": p+"toolbar_openlocalfile_24@2x-6f2ec1b46c.png",
        "toolbar_paragraph@2x": p+"toolbar_paragraph@2x-91a57ab5cd.png",
        "toolbar_paragraph_1.3@2x": p+"toolbar_paragraph_1-fa31ee026c.3@2x.png",
        "toolbar_paragraph_1.5@2x": p+"toolbar_paragraph_1-72b8443991.5@2x.png",
        "toolbar_paragraph_1@2x": p+"toolbar_paragraph_1@2x-8d1ca8ea7e.png",
        "toolbar_paragraph_2@2x": p+"toolbar_paragraph_2@2x-22e956c6d4.png",
        "toolbar_paragraph_3@2x": p+"toolbar_paragraph_3@2x-09ed968ad9.png",
        "toolbar_paragraph_addindent@2x": p+"toolbar_paragraph_addindent@2x-c651f82af0.png",
        "toolbar_paragraph_aligncenter@2x": p+"toolbar_paragraph_aligncenter@2x-8c227b3567.png",
        "toolbar_paragraph_alignleft@2x": p+"toolbar_paragraph_alignleft@2x-5023f53cad.png",
        "toolbar_paragraph_alignright@2x": p+"toolbar_paragraph_alignright@2x-97aebcf3d3.png",
        "toolbar_paragraph_end@2x": p+"toolbar_paragraph_end@2x-8138d55c7a.png",
        "toolbar_paragraph_itemdot@2x": p+"toolbar_paragraph_itemdot@2x-3c9a325853.png",
        "toolbar_paragraph_itemnumber@2x": p+"toolbar_paragraph_itemnumber@2x-450b6b44fd.png",
        "toolbar_paragraph_middle@2x": p+"toolbar_paragraph_middle@2x-c60d2b36a1.png",
        "toolbar_paragraph_reduceindent@2x": p+"toolbar_paragraph_reduceindent@2x-dcce1d080a.png",
        "toolbar_paragraph_top@2x": p+"toolbar_paragraph_top@2x-92ccbcefa6.png",
        "toolbar_photp@2x": p+"toolbar_photp@2x-1ef9636f6a.png",
        "toolbar_qrcode@2x": p+"toolbar_qrcode@2x-0ca7b94545.png",
        "toolbar_quote@2x": p+"toolbar_quote@2x-2aee22c125.png",
        "toolbar_redo@2x": p+"toolbar_redo@2x-e2ce3fdcf5.png",
        "toolbar_remarks@2x": p+"toolbar_remarks@2x-b86d2be674.png",
        "toolbar_row+line@2x": p+"toolbar_row+line@2x-8aeca9fde9.png",
        "toolbar_row+line_adddown@2x": p+"toolbar_row+line_adddown@2x-7595b153eb.png",
        "toolbar_row+line_addleft@2x": p+"toolbar_row+line_addleft@2x-901336067d.png",
        "toolbar_row+line_addright@2x": p+"toolbar_row+line_addright@2x-e215cc8113.png",
        "toolbar_row+line_addup@2x": p+"toolbar_row+line_addup@2x-0fc928b01c.png",
        "toolbar_shape@2x": p+"toolbar_shape@2x-33ed799665.png",
        "toolbar_sheet_protect@2x": p+"toolbar_sheet_protect@2x-cd985c4584.png",
        "toolbar_sheet_protect_open@2x": p+"toolbar_sheet_protect_open@2x-2575596191.png",
        "toolbar_text@2x": p+"toolbar_text@2x-2aa914bedb.png",
        "toolbar_text_10@2x": p+"toolbar_text_10@2x-a66c84a735.png",
        "toolbar_text_11@2x": p+"toolbar_text_11@2x-fe91a9bf5c.png",
        "toolbar_text_12@2x": p+"toolbar_text_12@2x-9ffff2bbb2.png",
        "toolbar_text_14@2x": p+"toolbar_text_14@2x-ce7c0e5c4b.png",
        "toolbar_text_16@2x": p+"toolbar_text_16@2x-74f7fc5cdf.png",
        "toolbar_text_18@2x": p+"toolbar_text_18@2x-06e25284d2.png",
        "toolbar_text_Italic@2x": p+"toolbar_text_Italic@2x-72474923fb.png",
        "toolbar_text_annotation@2x": p+"toolbar_text_annotation@2x-1fba07df5e.png",
        "toolbar_text_bold@2x": p+"toolbar_text_bold@2x-d995f3c013.png",
        "toolbar_text_color@2x": p+"toolbar_text_color@2x-f390dcd4d6.png",
        "toolbar_text_decrease@2x": p+"toolbar_text_decrease@2x-6a0a5f61fc.png",
        "toolbar_text_deleteline@2x": p+"toolbar_text_deleteline@2x-7e11c197b4.png",
        "toolbar_text_highlight@2x": p+"toolbar_text_highlight@2x-7e66fdcdb1.png",
        "toolbar_text_increase@2x": p+"toolbar_text_increase@2x-1e70cf0af4.png",
        "toolbar_text_maintext@2x": p+"toolbar_text_maintext@2x-bd5aa9fe8b.png",
        "toolbar_text_maintext_en@2x": p+"toolbar_text_maintext_en@2x-e1e22cce0c.png",
        "toolbar_text_smalltitle@2x": p+"toolbar_text_smalltitle@2x-cdb798946a.png",
        "toolbar_text_title1@2x": p+"toolbar_text_title1@2x-707074501c.png",
        "toolbar_text_title1_en@2x": p+"toolbar_text_title1_en@2x-2c6eb8202f.png",
        "toolbar_text_title2@2x": p+"toolbar_text_title2@2x-64842e0e96.png",
        "toolbar_text_title2_en@2x": p+"toolbar_text_title2_en@2x-8ec8fc15ed.png",
        "toolbar_text_title3@2x": p+"toolbar_text_title3@2x-2bbf7494cc.png",
        "toolbar_text_title3_en@2x": p+"toolbar_text_title3_en@2x-08ae08c409.png",
        "toolbar_text_title4@2x": p+"toolbar_text_title4@2x-650ac28bcd.png",
        "toolbar_text_title4_en@2x": p+"toolbar_text_title4_en@2x-a8f0dba3bc.png",
        "toolbar_text_title@2x": p+"toolbar_text_title@2x-4149f7b0c3.png",
        "toolbar_text_underline@2x": p+"toolbar_text_underline@2x-9e2cb8450c.png",
        "toolbar_textbox@2x": p+"toolbar_textbox@2x-e1a1138c3c.png",
        "toolbar_todo@2x": p+"toolbar_todo@2x-76821d2166.png",
        "toolbar_transform@2x": p+"toolbar_transform@2x-4409fb136a.png",
        "toolbar_undo@2x": p+"toolbar_undo@2x-41b3fa5497.png",
        "toolbar_view@2x": p+"toolbar_view@2x-f1ab0b4815.png",
        "toolbar_view_filter@2x": p+"toolbar_view_filter@2x-71d840bbc6.png",
        "toolbar_voice@2x": p+"toolbar_voice@2x-742faa3e5f.png",
        "toolbar_wordwrap@2x": p+"toolbar_wordwrap@2x-cff8211c6e.png",
        "upload_arrow@2x": p+"upload_arrow@2x-429fb3c219.png",
        "view_results@2x": p+"view_results@2x-c3b014a149.png",
        "vip_cdk_logo@2x": p+"vip_cdk_logo@2x-2df9533f47.png",
        "vip_cdk_pattern@2x": p+"vip_cdk_pattern@2x-ab39d62958.png",
        "vip_center_card_default_172@2x": p+"vip_center_card_default_172@2x-e0b1f79b6a.png",
        "vip_center_card_svip_108@2x": p+"vip_center_card_svip_108@2x-9b332ca698.png",
        "vip_center_card_svip_172@2x": p+"vip_center_card_svip_172@2x-2ff472a7ce.png",
        "vip_center_card_vip_108@2x": p+"vip_center_card_vip_108@2x-5eec305232.png",
        "vip_center_card_vip_172@2x": p+"vip_center_card_vip_172@2x-080420b53e.png",
        "vip_diamond_bg_line_mobile@2x": p+"vip_diamond_bg_line_mobile@2x-63df19e883.png",
        "vip_diamond_disable@2x": p+"vip_diamond_disable@2x-6b9a566bc8.png",
        "vip_diamond_normal@2x": p+"vip_diamond_normal@2x-22b07148c0.png",
        "vip_login_qq @2x": p+"vip_login_qq @2x-57820a9b7e.png",
        "vip_login_wechat@2x": p+"vip_login_wechat@2x-ee06ee31f5.png",
        "vip_login_wechatwork @2x": p+"vip_login_wechatwork @2x-bd4899eb02.png",
        "vip_smalldiamond_normal@2x": p+"vip_smalldiamond_normal@2x-d84a209699.png",
        "vip_tag@2x": p+"vip_tag@2x-d95aa7cb97.png",
        "voiceinput_pause@2x": p+"voiceinput_pause@2x-c8b760a55e.png",
        "voiceinput_tab@2x": p+"voiceinput_tab@2x-4d07a5baaa.png",
        "watermark_intensive@2x": p+"watermark_intensive@2x-c1f22638af.png",
        "watermark_loose@2x": p+"watermark_loose@2x-c898528da5.png",
        "watermark_no@2x": p+"watermark_no@2x-14ce938c20.png",
        "wechat_channels@2x": p+"wechat_channels@2x-1db1c6895d.png",
        "wechat_miniprograms@2x": p+"wechat_miniprograms@2x-2a2b919083.png",
        "wedrive_file_or_doc_menu_addmember@2x": p+"wedrive_file_or_doc_menu_addmember@2x-d9cd5b5c3c.png",
        "wedrive_file_or_doc_menu_authority@2x": p+"wedrive_file_or_doc_menu_authority@2x-9d68ad3e73.png",
        "wedrive_link@2x": p+"wedrive_link@2x-1975e53e29.png",
        "wedrive_share@2x": p+"wedrive_share@2x-19fd1e916d.png",
    };
})();